import {
  Search,
  Plus,
  Edit,
  UserRound,
  MapPin,
  Phone,
  Mail,
  FileText,
  IndianRupee,
  Tag,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../axiosinstance";
import { IoIosSearch } from "react-icons/io";
import { LuPlus } from "react-icons/lu";
import "./Subsidary.css";
import { CiMenuBurger } from "react-icons/ci";
import { IoCloseOutline } from "react-icons/io5";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export default function SubsidiaryCard({ isSidebarExpanded }) {
  const [subsidaryData, setSubsidaryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchVisible, setSearchVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [maxSubsidiaries, setMaxSubsidiaries] = useState(0);
  const [newButtonVisible, setNewButtonVisible] = useState(true);
  const containerRef = useRef(null);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const navigate = useNavigate();
  const [selectedSubsidiary, setSelectedSubsidary] = useState([]);
  const [selectedSubsidiaries, setSelectedSubsidiaries] = useState([]);
  const [selectedFirms, setSelectedFirms] = useState([]);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [userRole, setUserRole] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSubsidary = () => {
    if (subsidaryData.length >= maxSubsidiaries) {
      // Reset snackbar to trigger animation on repeated clicks
      setSnackbarOpen(false);
      setTimeout(() => {
        setSnackbarMessage(
          `Maximum subsidiary limit reached. You cannot create more subsidiaries.`
        );
        setSnackbarOpen(true);
      }, 100);
      return;
    }
    navigate("/new-subsidary");
  };

  const handleCancel = () => {
    setIsDeletePopup(false);
  };

  useEffect(() => {
    const role = localStorage.getItem("user_role");
    setUserRole(role);
  }, []);

  const handleCheckboxChange = (subsidiaryId) => {
    setSelectedSubsidiaries((prev) =>
      prev.includes(subsidiaryId)
        ? prev.filter((id) => id !== subsidiaryId)
        : [...prev, subsidiaryId]
    );
  };

  console.log("Selected Subsidiaries:", selectedSubsidiaries);

  const fetchData = async (status = "Active") => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/api/get_all_subsidiary?page_status=${status}`
      );

      const responseData = response.data.data || [];
      setSubsidaryData(responseData);

      // Add this line to get max subsidiaries from the same response
      setMaxSubsidiaries(response.data.maximum_subsidiary || 0);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching firm data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // setNewButtonVisible(subsidaryData.length <= maxSubsidiaries);
  }, [subsidaryData, maxSubsidiaries]);

  const handleSearch = async (e, status = "Active") => {
    const query = e.target.value;
    setSearchQuery(query);

    if (!query.trim()) {
      fetchData();
    } else {
      try {
        setLoading(true);
        const response = await axiosInstance.get(
          `/api/search_subsidiary?page_status=${status}`,
          { params: { query } }
        );
        setSubsidaryData(response.data.data || []);

        // Add this line
        if (response.data.maximum_subsidiary !== undefined) {
        setMaxSubsidiaries(response.data.maximum_subsidiary);
      }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching search results:", error.message);
        setLoading(false);
      }
    }
  };

  const highlightText = (text) => {
    if (!searchQuery.trim()) return text;
    const regex = new RegExp(`(${searchQuery})`, "gi");
    return text.split(regex).map((part, index) =>
      part.toLowerCase() === searchQuery.toLowerCase() ? (
        <span key={index} className="highlight">
          {part}
        </span>
      ) : (
        part
      )
    );
  };
  const handleArchiveSubsidiary = async () => {
    if (selectedSubsidiaries.length === 0) {
      alert("Please select at least one Subsidiary to archive.");
      return;
    }

    try {
      const response = await axiosInstance.put(`/api/archive_subsidiary`, {
        ids: selectedSubsidiaries,
      });

      if (response.status === 200) {
        console.log("Success");
        await fetchData(); // Refresh client list after archiving
        setSelectedSubsidiaries([]); // Clear after successful archive
        // setSelectAll(false);
      } else {
        alert(
          response.data.message ||
            "Failed to archive Subsidiary. Please try again."
        );
      }
    } catch (error) {
      console.error("Error archiving Subsidiary:", error);
      alert(
        error.response?.data?.message ||
          "An unexpected error occurred while archiving Subsidiary."
      );
    } finally {
      setIsDeletePopup(false); // Ensure popup closes after action
    }
  };

  const handleArchivedTable = () => {
    navigate("/archived-subsidary");
  };

  const handleSortpopup = () => {
    setIsSortPopup(!isSortPopup);
  };

  const handleEdit = (subsidiaryId) => {
    navigate(`/Edit-subsidary/${subsidiaryId}`);
  };
  const handleDeletePopup = () => {
    setIsDeletePopup(true);
  };

  return (
    <div
      className={`table-container subsidiary-page ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="table-container-content subsidiary-page-content">
        <div className="table-header">
          {selectedSubsidiaries.length > 0 ? (
            <div className="table-header-content archive-header">
              <button className="delete" onClick={handleDeletePopup}>
                Move to Archive
              </button>
              <button
                className="action-header-close-button"
                onClick={() => setSelectedSubsidiaries([])}
              >
                <IoCloseOutline className="action-header-close-icon" />
              </button>
            </div>
          ) : (
            <div className="table-header-content">
              <div className="table-left-side">
                <h2 className="jost-bold">Subsidiary</h2>
              </div>
              <div className="table-right-side">
                <div className="search-bar-container">
                  <input
                    type="text"
                    placeholder="Search ..."
                    className="search-bar"
                    value={searchQuery}
                    onChange={handleSearch} // Use handleSearch to update search query and fetch data
                  />
                  <IoIosSearch className="search-bar-icon" />
                </div>

                {/* {newButtonVisible && (
                  <div className="new-button" onClick={handleSubsidary}>
                    <span className="new-icon">
                      <LuPlus />
                    </span>
                    <span>New</span>
                  </div>
                )} */}

                {userRole !== "User" && (
                  <>
                    <div
                      className="new-button"
                      onClick={handleSubsidary}
                      style={{
                        opacity:
                          subsidaryData.length >= maxSubsidiaries ? 0.5 : 1,
                        cursor:
                          subsidaryData.length >= maxSubsidiaries
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      <span className="new-icon">
                        <LuPlus />
                      </span>
                      <span>New</span>
                    </div>
                    <Snackbar
                      open={snackbarOpen}
                      autoHideDuration={6000}
                      onClose={handleSnackbarClose}
                      anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                      <Alert
                        onClose={handleSnackbarClose}
                        severity="error"
                        sx={{
                          width: "100%",
                          "& .MuiAlert-icon": {
                            color: "#ef5350",
                          },
                          "& .MuiAlert-message": {
                            color: "#ef5350",
                            fontWeight: 500,
                          },
                        }}
                      >
                        {snackbarMessage}
                      </Alert>
                    </Snackbar>
                  </>
                )}

                {/* <button className="sort-button" onClick={handleSortpopup}>
                  <CiMenuBurger className="sort-icon" />
                </button> */}

                {isSortPopup && (
                  <div className="sort-popup-container" ref={containerRef}>
                    <button
                      className="delete-item"
                      onClick={handleArchivedTable}
                    >
                      Archived Subsidiary
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {isDeletePopup && (
          <div className="confirm-delete-popup">
            <div className="confirm-delete-popup-content">
              <div className="confirm-model">
                <div className="confirm-model-content">
                  <div className="confirm-model-content-body">
                    <p>Are you sure you want to move to archive?</p>
                  </div>
                  <div className="confirm-model-content-footer">
                    <button
                      className="confirm-delete-button"
                      onClick={handleArchiveSubsidiary}
                    >
                      Yes
                    </button>
                    <button
                      className="confirm-cancel-button"
                      onClick={handleCancel}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="data-list-body dlb-h100 subsidiary-data-body">
          <div className="data-list-scroll-body dl-sb-h100 subsidiary-scroll-body">
            {loading ? (
              <p>Loading...</p>
            ) : subsidaryData.length === 0 ? (
              <p>Currently, there are no records to display</p>
            ) : (
              <div className="cards-container">
                {subsidaryData.map((subsidiary, index) => (
                  <div className="card" key={subsidiary.subsidiary_id || index}>
                    <div className="company-header">
                      <div className="company-name">
                        {/* <input
                          type="checkbox"
                          checked={selectedSubsidiaries.includes(
                            subsidiary.subsidiary_id
                          )}
                          onChange={() =>
                            handleCheckboxChange(subsidiary.subsidiary_id)
                          }
                          className="subsidiary-checkbox"
                        /> */}

                        <span className="label jost-bold">
                          {highlightText(
                            subsidiary.tag_name?.toUpperCase() || ""
                          )}
                        </span>
                        <h2 className="jost-bold">
                          {highlightText(
                            subsidiary.Subsidiary_name?.toUpperCase() || "N/A"
                          )}
                        </h2>
                      </div>
                    </div>

                    <div className="details">
                      <div className="detail-row">
                        <span className="detail-label">
                          <UserRound className="detail-icon" />
                          <span>Proprietor / Owner</span>
                        </span>
                        <span className="detail-value highlight-blue">
                          {highlightText(subsidiary.Subsidiary_owner || "N/A")}
                        </span>
                      </div>

                      <div className="detail-row">
                        <span className="detail-label">
                          <MapPin className="detail-icon" />
                          <span>Address</span>
                        </span>
                        <span className="detail-value highlight-orange">
                          {highlightText(subsidiary.address || "N/A")}
                        </span>
                      </div>

                      <div className="detail-row">
                        <span className="detail-label">
                          <Phone className="detail-icon" />
                          <span>Number</span>
                        </span>
                        <span className="detail-value highlight-number">
                          {highlightText(subsidiary.contact_no || "N/A")}
                        </span>
                      </div>

                      <div className="detail-row">
                        <span className="detail-label">
                          <Mail className="detail-icon" />
                          <span>Email Id</span>
                        </span>
                        <span className="detail-value highlight-email">
                          {highlightText(subsidiary.email_id || "N/A")}
                        </span>
                      </div>

                      <div className="detail-row">
                        <span className="detail-label">
                          <FileText className="detail-icon" />
                          <span>GST No.</span>
                        </span>
                        <span className="detail-value highlight-blue">
                          {highlightText(
                            subsidiary.gstNumber || "Not Available"
                          )}
                        </span>
                      </div>

                      <div className="detail-row">
                        <span className="detail-label">
                          <IndianRupee className="detail-icon" />
                          <span>Invoicing Limit</span>
                        </span>
                        <span className="detail-value highlight-invoice">
                          {highlightText(subsidiary.invoicing_limit || "N/A")}
                        </span>
                      </div>

                      <div className="detail-row">
                        <span className="detail-label">
                          <Tag className="detail-icon" />
                          <span>Tag</span>
                        </span>
                        <span className="detail-value highlight-green highlight-tag">
                          {highlightText(subsidiary.tag_name || "N/A")}
                        </span>
                      </div>
                    </div>

                    {userRole === "CA Admin" && (
                      <div className="edit-btn-container">
                        <button
                          className="edit-btn"
                          onClick={() => handleEdit(subsidiary.subsidiary_id)}
                        >
                          <Edit size={16} /> Edit
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
